import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Context } from "types/generated";

const ContextsTableDescriptionCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<Context>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={context.description} />
    </TableSimpleCell>
  );
};

export default ContextsTableDescriptionCell;
